/* src/app/pages/credit-cards/transactions-table/transactions-table.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  display: block;
}
.transactions-section {
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 16px;
}
.transactions-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.transactions-title {
  font-family: var(--cds-font-family);
  font-size: 18px;
  font-weight: 700;
  color: --cds-text-strong;
  line-height: 1;
  margin: 0;
  font-feature-settings: "ss01" 1;
}
.transactions-empty {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: 400;
  color: --cds-text-medium;
  line-height: 1;
  margin: 0;
}
:host ::ng-deep .transactions-section .table-header {
  font-size: 16px;
}
:host ::ng-deep .transactions-section .table-cell {
  font-size: 16px;
  padding-left: 16px;
  padding-right: 16px;
}
/*# sourceMappingURL=transactions-table.component.css.map */
